import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { Box, Typography } from '@mui/material';
import { getTenantConfig } from './theme/tenantConfigs';

interface TenantConfig {
  primaryColor: string;
}

const HomePage: React.FC = () => {
  const { user } = useAuth0();
  const navigate = useNavigate();
  const givenName = user?.given_name || user?.name || 'Guest';
  const tenant = getTenantConfig() as TenantConfig;

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Typography variant="h1" sx={{ fontSize: '1.5rem' }}>
          Welcome, {givenName}!
        </Typography>
      </Box>
      
      <Typography variant="body1" sx={{ fontSize: '.9rem', mb: 4 }}>
        This is your personal healthcare assistant. Navigate through our features
        using the bottom tabs to explore Dr Bill's expertise, access your Benefits
        Concierge, or manage your Account settings.
      </Typography>

      <Typography variant="h2" sx={{ fontSize: '1rem', mb: 3 }}>
        Quick Navigation Guide
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box onClick={() => navigate('/ask-dr-bill')} sx={{ cursor: 'pointer' }}>
          <Typography variant="h3" sx={{ fontSize: '1rem', color: tenant.primaryColor }}>
            Ask Dr Bill
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '.9rem' }}>
            Get instant answers to your medical queries and health concerns
          </Typography>
        </Box>

        <Box onClick={() => navigate('/benefits-concierge')} sx={{ cursor: 'pointer' }}>
          <Typography variant="h3" sx={{ fontSize: '1rem', color: tenant.primaryColor }}>
            Benefits Concierge
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '.9rem' }}>
            Explore your plan details and maximize your healthcare benefits
          </Typography>
        </Box>

        <Box onClick={() => navigate('/account')} sx={{ cursor: 'pointer' }}>
          <Typography variant="h3" sx={{ fontSize: '1rem', color: tenant.primaryColor }}>
            Your Account
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '.9rem' }}>
            Manage your profile, preferences, and personal settings
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HomePage;